<template>
  <section>
    <Background bgColor="gray">
      <Container>
        <div class="gap-20px flex flex-col">
          <VimeoVideo :videoId="videoId" :videoTitle="title" />
          <Heading :headingTag="'h3'" :style="'h3'">
            {{ title }}
          </Heading>
          <Paragraphs>
            <slot></slot>
          </Paragraphs>
        </div>
      </Container>
    </Background>
  </section>
</template>

<script>
import Background from "../Atoms/Background.vue";
import Heading from "../Atoms/Heading.vue";
import Paragraphs from "../Atoms/Paragraphs.vue";
import VimeoVideo from "../Atoms/VimeoVideo.vue";

import useHasSlot from "../../compostables/useHasSlot";
import Container from "../Atoms/Container.vue";

export default {
  components: {
    VimeoVideo,
    Heading,
    Paragraphs,
    Background,
    Container,
  },

  props: {
    videoId: {
      type: String,
    },
    title: {
      type: String,
    },
    data: {
      type: Object,
      required: false,
    },
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);
    let dataComp = {
      videoId: props.videoId,
      title: props.title,
    };

    if (props.data) {
    }
    return {
      hasSlot,
    };
  },
};
</script>
